import React from "react";
import { adRefresh } from "../../lib/AdCommon";

interface IProps {
  slot: string;
  refresh: boolean;
}

interface IState {
  first: boolean;
  isLoaded: boolean;
}

class AdScrollRefresh extends React.PureComponent<IProps, IState> {
  static defaultProps = {
    refresh: true,
  };
  private adRef = React.createRef<HTMLDivElement>();
  private observer: IntersectionObserver | null = null;
  constructor(props: IProps) {
    super(props);
    this.state = {
      first: false,
      isLoaded: false,
    };
  }
  componentDidMount() {
    const { slot, refresh } = this.props;
    if (!refresh) return;
    let ref = this.adRef.current;
    try {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (this.state.first) {
            if (entries[0].isIntersecting) {
              adRefresh(slot);
              this.setState({ isLoaded: true });
            }
          } else {
            this.setState({ first: true });
          }
        },
        {
          threshold: [0.75],
        },
      );
      if (ref) {
        this.observer.observe(ref);
      }
    } catch (e) {
      // 检查组件是否已卸载
      this.setState({ isLoaded: false });
      console.log("error:", e);
    }
  }

  disconnect() {
    if (this.observer && this.adRef.current) {
      this.observer.unobserve(this.adRef.current);
      this.observer.disconnect();
    }
  }

  // componentDidUpdate(): void {
  //   if (this.state.first && this.state.isLoaded) {
  //     this.disconnect();
  //   }
  // }

  componentWillUnmount() {
    this.disconnect();
    this.observer = null;
  }

  render() {
    const { children } = this.props;

    return <div ref={this.adRef}>{children}</div>;
  }
}

export default AdScrollRefresh;
